/**
 * Created by pandemio on 2/28/19.
 */
import React from 'react';
import { Redirect } from "react-router-dom";
import { Container, FormGroup, Col, Label, Alert, Row, Button, Card, CardBody} from 'reactstrap';
/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import global from "../translations/global.json";
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import NavbarDesktop from './navbar/navbar-desktop-top';
import NavbarMobile from './navbar/navbar-mobile';
import Settings from '../custom-classes/settings';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import FormGroupPassword from './forms/form-group-new-password';
import FormGroupUsername from './forms/form-group-username';
import FromGroupEmail from './forms/form-group-email';
import FormGroupAddress from './forms/form-group-address';
import FormGroupName from './forms/form-group-name';
import FormGroupPhone from './forms/form-group-phone';
import ModalChildrenPolicy from './modals/modal-child-policy';
import ModalTerms from './modals/modal-terms';
import CheckoutForm from './stripe/stripe-card';
import {Elements, StripeProvider} from 'react-stripe-elements';
import NumericInput from 'react-numeric-input';
import ApiCalls from '../custom-classes/api-calls';
import LoaderFullWindow from './loader-windows/loader-full-window';
import ModalGeneric from './modals/modal-generic';
import ModalSuccess from './modals/modal-success-registration';
import SessionManager from '../custom-classes/session-manager';
//import ChatClient from './chat/chat-client';
import FormGroupCoupon from './forms/form-coupon';
import CalculationBox from './calculation-box/calculation-box';
import LiveChat from 'react-livechat';

import {faPencilAlt, faTabletAlt, faChartPie, faGraduationCap, faPlusCircle} from '@fortawesome/free-solid-svg-icons';

/**
 * The component (window) to register and subscribe a client for the first time. It's a single page subscription
 */
class SinglePageSubscription extends React.Component{


    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage() }
        });
        this.props.addTranslation(global);

        this.state = {
            mobile: false,
            didMount: false,
            password: '',
            passwordRetype: '',
            username: '',
            validUsername: true,
            usernameAvailable: true,
            validPassword: true,
            validEmail: true,
            email: '',
            phone: '',
            validPhone: true,
            firstName: '',
            lastName: '',
            validFirstName: true,
            validLastName: true,
            addressLine1: '',
            addressLine2:'',
            studentsQuantity: 1,
            city: '',
            country: '',
            state: '',
            zipCode: '',
            validAddress: true,
            validCity: true,
            validCountry: true,
            validState: true,
            validZipCode: true,
            stripeApiKey: Settings.getStripeToken(),
            subTokenStripe: null,
            planCostDetails: false,
            validCalculation: false,
            planAvailableForIso: true,
            planId: props.location.planId,
            subscriptionId: '',
            previousAddressState: '',
            previousAddressCountry: '',
            loading: false,
            showErrorModal: false,
            showModalSuccess: false,
            chatOn: false,
            couponPlatformId: null,
            chatLiveChatLicense: Settings.CHAT_LIVE_CHAT_LICENSE
        };

        this.handleQuantityProfilesChange = this.handleQuantityProfilesChange.bind(this);
        this.submitRegistration = this.submitRegistration.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleSuccessModal = this.toggleSuccessModal.bind(this);
        this.setCouponCode = this.setCouponCode.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.setState({didMount: true},()=>{
            this.calculateCosts();
            this.checkIfChatAvailable();
        });
    }

    /**
     * Toggles the success modal
     */
    toggleSuccessModal(){
        this.setState({showModalSuccess: false});

    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal() {
        this.setState({showErrorModal: false});
    }

    /**
     * Check if the chat is available or not
     */
    checkIfChatAvailable(){
        // This is promise
        let apiCall = ApiCalls.getChatStatus();
        // After the api call, fill the data
        apiCall.then((data)=> {
            this.setState({chatOn: data.IsChatTurnedOn});
        });
    }

    /**
     * Submits the registration
     */
    submitRegistration(){

        this.setState({
            loading: true
        });

        if(this.state.validUsername && this.state.usernameAvailable
            && this.state.username !== null && this.state.username !== ''
            && this.state.validPassword && this.state.validAddress
            && this.state.password !== null && this.state.password !== ''
            && this.state.passwordRetype !== null && this.state.passwordRetype !== ''
            && this.state.validCity && this.state.validCountry
            && this.state.city !== null && this.state.city !== ''
            && this.state.validState && this.state.validZipCode
            && this.state.validEmail && this.state.validPhone
            && this.state.email !== null && this.state.phone !== ''
            && this.state.validFirstName && this.state.validLastName
            && this.state.firstName !== null && this.state.lastName !== ''
            && this.state.validCalculation && this.state.subTokenStripe !== null
            && this.state.subTokenStripe !== '' && this.state.planId !== null
            && typeof this.state.planId !== 'undefined')
        {
            // Saves the new password
            let apiCall = ApiCalls.registerOnePageForm(
                this.state.firstName,
                this.state.lastName,
                this.state.phone,
                this.state.addressLine1,
                this.state.addressLine2,
                this.state.city,
                this.state.state,
                this.state.state,
                this.state.country,
                this.state.zipCode,
                this.state.country,
                this.state.planId,
                this.state.subTokenStripe,
                this.state.studentsQuantity,
                this.state.email,
                this.state.username,
                this.state.password,
                this.state.passwordRetype,
                this.state.couponPlatformId);
            apiCall.then((data)=> {
                //If transaction is valid, then show true (TransactionValid)
                if(!data.TransactionValid)
                {
                    let propsModal = {
                        bodyText: data.Messages[0],
                        visible: true
                    };
                    this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
                }
                else
                {
                    // If Token is not null, set token (Token)
                    // Set success message
                    SessionManager.setSession(data.Token);
                    this.setState({subscriptionId: data.Subscriptions[0].SubscriptionId,
                        showModalSuccess: true, loading: false});
                }

            });
        }
        else
        {
            this.setState({
                loading: false
            });
        }
    }

    /**
     * Saves the username state and verifies if the next button is ready
     * @param field
     */
    saveUsername = (field) => (newValue) => {
        this.setState({
            username: newValue.username,
            validUsername: newValue.validUsername,
            usernameAvailable: newValue.usernameAvailable
        });
    };

    /**
     * Save the password state and verifies if the next button is ready
     * @param field
     */
    savePassword = (field) => (newValue) => {
        this.setState({
            password: newValue.password,
            passwordRetype: newValue.passwordRetype,
            validPassword: newValue.validPassword
        });
    };

    /**
     * Save the email state and verifies  if the next button is ready
     * @param field
     */
    saveEmail = (field) => (newValue) => {
        this.setState({
            email: newValue.email,
            validEmail: newValue.validEmail,
            emailAvailable: newValue.emailAvailable
        });
    };

    /**
     * Save the name details and verifies if the next button is ready
     * @param field
     */
    saveName = (field) => (newValue) => {
        this.setState({
            firstName: newValue.firstName,
            lastName: newValue.lastName,
            validFirstName: newValue.validFirstName,
            validLastName: newValue.validLastName
        });
    };

    /**
     * Save the phone details and verifies if the next button is ready
     * @param filed
     */
    savePhone = (filed) => (newValue) => {
        this.setState({phone: newValue.phone, validPhone: newValue.validPhone});
    };

    /**
     * Saves the address details and verifies if the next button is ready
     * @param field
     */
    saveAddress = (field) => (newValue) => {
        this.setState(
            {
                addressLine1: newValue.addressLine1,
                addressLine2: newValue.addressLine2,
                city: newValue.city,
                country: newValue.country,
                state: newValue.state,
                zipCode: newValue.zipCode,
                validAddress: newValue.validAddress,
                validCity: newValue.validCity,
                validCountry: newValue.validCountry,
                validPhone: newValue.validPhone,
                validState: newValue.validState,
                validZipCode: newValue.validZipCode
            }, () => {
                if(this.state.previousAddressState !== this.state.state)
                {
                    this.setState({
                        previousAddressState: this.state.state
                    },()=>{
                        this.calculateCosts();
                    });
                }
                if(this.state.previousAddressCountry !== this.state.country){
                    this.setState({
                        previousAddressCountry: this.state.country
                    },()=>{
                        this.calculateCosts();
                    });
                }
            });
    };

    /**
     * Set the stripe payment token
     * @param field
     */
    setStripePaymentToken = (field) => (newValue) =>{

        if(newValue == null)
            this.setState({
                subTokenStripe: null
            });
        else
        {
            this.setState({
                subTokenStripe: newValue.id
            });
        }
    };


    /**
     * Render the total details
     * @param costData
     * @returns {*}
     */
    renderTotals(costData){
        return(
            <CalculationBox costData={{costData}}/>
        );
    }


    /**
     * Calculate the costs in the service
     */
    calculateCosts(){
        if(this.state.studentsQuantity > 0)
        {
            // Calculate cost
            let apiCall = ApiCalls.getPlanTotalCosts(
                this.state.planId,
                this.state.studentsQuantity,
                this.state.couponPlatformId,
                this.state.state,
                this.state.country);
            apiCall.then((data)=> {
                if(data.PlanCosts !== null)
                    this.setState({validCalculation: true});
                else
                    this.setState({validCalculation: false});

                this.setState({planCostDetails: this.renderTotals(data)});
            });
        }
        else
        {
            this.setState({planCostDetails: null, validCalculation: false});
        }
    }

    /**
     * Action when the selection of quantity of student changes
     * @param e
     */
    handleQuantityProfilesChange(value) {
        this.setState({ studentsQuantity:value},()=>{
            this.calculateCosts();
        });
    }

    /**
     * Toggle the terms modal
     */
    toggleModalTerms() {
        this.setState({showModalTerms: !this.state.showModalTerms});
    }

    /**
     * Toggle de modal children policy
     */
    toggleModalChildrenPolicy() {
        this.setState({showModalChildrensPolicy: !this.state.showModalChildrensPolicy});
    }

    setCouponCode(e){
        this.setState({couponPlatformId: e},()=>{
            this.calculateCosts();
        });
    }

    /**
     * To evaluate when the screen size changed
     */
    resize() {
        this.setState({mobile: window.screen.width <= 1024});
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        if(this.state.planId === null || typeof this.state.planId === 'undefined')
            return (<Redirect  to={{
                pathname: "/select-plan"
            }}/>);

            return (
                <div>
                    {this.state.mobile ? <NavbarMobile/> : <NavbarDesktop/>}
                    <div className="container-padding card-white">
                        <Container className="margin-top-mandatory-60">
                        <Row className="centered-text">
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="registration-full-form.become-a-member"/>
                                </h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{size:12}} sm={{size: 12}} md={{size: 6}} lg={{size: 6}}>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <Card className="card-orange">
                                            <CardBody>
                                                <h2 className="font-now-bold"> <Translate id="registration-full-form.membership-includes"/></h2>
                                                <hr/>
                                                <h3 className="font-now-bold">
                                                    <FontAwesomeIcon className="fa-1x" icon={faPencilAlt}/>{' '}
                                                    <Translate id="registration-full-form.more-activities"/></h3>
                                                <h3 className="font-now-bold">
                                                    <FontAwesomeIcon className="fa-1x" icon={faTabletAlt}/>{' '}
                                                    <Translate id="registration-full-form.access"/></h3>
                                                <h3 className="font-now-bold">
                                                    <FontAwesomeIcon className="fa-1x" icon={faChartPie}/>{' '}
                                                    <Translate id="registration-full-form.track-progress"/></h3>
                                                <h3 className="font-now-bold">
                                                    <FontAwesomeIcon className="fa-1x" icon={faGraduationCap}/>{' '}
                                                    <Translate id="registration-full-form.grades"/></h3>
                                                <h3 className="font-now-bold">
                                                    <FontAwesomeIcon className="fa-1x" icon={faPlusCircle}/>{' '}
                                                    <Translate id="registration-full-form.and-more"/></h3>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                            <Col style={{border: 'solid lightgray', backgroundColor: 'whitesmoke'}} xs={{size:12}} sm={{size: 12}} md={{size: 6}} lg={{size: 6}}>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <div className="align-vertical-center">
                                            <span style={{float:'left'}} className="circle-btn">1</span>
                                            <h2 className="font-now-bold margin-left title">
                                                <Translate id="registration-full-form.create-your-account"/>
                                            </h2>
                                        </div>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroupUsername data={this.state} updateParent={this.saveUsername()}/>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroupPassword data={this.state} updateParent={this.savePassword()}/>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FromGroupEmail data={this.state} updateParent={this.saveEmail()}/>
                                    </Col>
                                </Row>
                                <hr/>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <div className="align-vertical-center">
                                            <span style={{float:'left'}} className="circle-btn">2</span>
                                            <h2 className="font-now-bold margin-left title">
                                                <Translate id="registration-full-form.enter-your-info"/></h2>
                                        </div>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroupName data={this.state} updateParent={this.saveName()}/>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroupAddress data={this.state} updateParent={this.saveAddress()}/>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroupPhone data={this.state} updateParent={this.savePhone()}/>
                                    </Col>
                                </Row>
                                <hr/>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <div className="align-vertical-center">
                                            <span style={{float:'left'}} className="circle-btn">3</span>
                                            <h2 className="font-now-bold margin-left title">
                                                <Translate id="registration-full-form.choose-quantity"/>
                                            </h2>
                                        </div>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <Label for="plan">
                                            <Translate id="registration-full-form.choose-quantity-instructions"/>
                                        </Label>
                                        <NumericInput
                                            defaultValue={1}
                                            onChange={this.handleQuantityProfilesChange}
                                            className="form-control" strict={true} min={1}
                                            max={5} mobile={'auto'} />
                                    </Col>
                                </Row>
                                <FormGroupCoupon updateParent={this.setCouponCode}/>
                                <hr/>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <div className="align-vertical-center">
                                            <span style={{float:'left'}} className="circle-btn">4</span>
                                            <h2 className="font-now-bold margin-left title">
                                                <Translate id="registration-full-form.credit-card-info"/>
                                            </h2>
                                        </div>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroup row>
                                            <Col sm={{ size: 10, offset: 1 }}>
                                                <StripeProvider apiKey={this.state.stripeApiKey}>
                                                    <Elements>
                                                        <CheckoutForm data={this.state.stripeUpdatePayment}
                                                                      updateParent={this.setStripePaymentToken()} />
                                                    </Elements>
                                                </StripeProvider>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <hr/>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroup row>
                                            {this.state.planCostDetails !== null ? this.state.planCostDetails : null}
                                        </FormGroup>

                                        {!this.state.planAvailableForIso ?
                                            <FormGroup row>
                                                <Col sm={{ size: 10, offset: 1 }}>
                                                    <Alert color="danger" isOpen={!this.state.planAvailableForIso}>
                                                        <Translate id="plan-calculator-form.plan-not-available-for-your-country"/>
                                                    </Alert>
                                                </Col>
                                            </FormGroup> : null
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <small>
                                            <Translate id="registration-full-form.by-submitting"/>
                                            <ModalChildrenPolicy isOpen={this.state.showModalChildrensPolicy} toggle={this.toggleModalChildrenPolicy}/>
                                            <ModalTerms isOpen={this.state.showModalTerms} toggle={this.toggleModalTerms} color="link"/>
                                        </small>
                                        <hr/>
                                        {
                                            !this.state.validUsername || !this.state.usernameAvailable
                                            || !this.state.validPassword || !this.state.validAddress
                                            || !this.state.validCity || !this.state.validCountry
                                            || !this.state.validState || !this.state.validZipCode
                                            || !this.state.validEmail || !this.state.validPhone
                                            || !this.state.validFirstName || !this.state.validLastName
                                            || !this.state.validCalculation || this.state.subTokenStripe === null
                                            || this.state.subTokenStripe === '' ?
                                            <Alert color="danger" isOpen={this.state.planAvailableForIso}>
                                                <Translate id="register.check-fields"/>
                                            </Alert> : null
                                        }
                                        <br/>
                                      <Button block color="success" className="font-now" onClick={this.submitRegistration}>
                                          <h2>
                                              <Translate id="registration-full-form.submit-payment"/>
                                          </h2>
                                      </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                            <LiveChat license={this.state.chatLiveChatLicense} />
                    </Container>

                    </div>
                    {this.state.loading ? <LoaderFullWindow/> : null}
                    {this.state.showErrorModal ? <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
                    {this.state.showModalSuccess ?
                        <ModalSuccess
                            isEdit={false}
                            visible={this.state.showModalSuccess}
                            subscriptionId={this.state.subscriptionId}
                            orderNo={"ORD" + this.state.subscriptionId}
                            updateParent={this.toggleSuccessModal}/> : null}
                    <Footer/>
                </div>
            )
        }

}

export default withLocalize(SinglePageSubscription);